import { Dispatch, SetStateAction } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import { GridRowOrderChangeParams } from '@mui/x-data-grid-pro';

import { Tab } from '../../../../common/contracts';
import DataTable from '../../../DataTable/DataTable';
import { CurrentTabItem, TabsItem } from '../storeTheme.types';

interface TabsTableProps {
  tabs: TabsItem[];
  setCurrentTab: Dispatch<SetStateAction<CurrentTabItem | null>>;
  setTabs: Dispatch<SetStateAction<TabsItem[]>>;
  setFieldValue: any;
  setEditedTabId: Dispatch<SetStateAction<string>>;
}

export const StoreTabsTable = ({
  tabs,
  setTabs,
  setFieldValue,
  setCurrentTab,
  setEditedTabId
}: TabsTableProps) => {
  const editTab = (row: Tab) => {
    setCurrentTab({ ...row });
    setEditedTabId(row.publisherTabId);
  };

  const removeTab = (id: string) => {
    const existingTab = tabs.find(
      (tab: TabsItem) => tab.publisherTabId === id && tab.tabId
    );
    const updatedTabsList = existingTab
      ? tabs.map((tab) => {
          if (tab.publisherTabId === id) {
            return { ...tab, toBeDeleted: true };
          }
          return tab;
        })
      : tabs.filter((tab) => tab.publisherTabId !== id);
    setTabs(updatedTabsList);
    setFieldValue('tabs', updatedTabsList);
  };

  const tabsData = tabs.filter((tab) => !tab.toBeDeleted);

  const handleTabsOrderChange = (targetIndex: number, oldIndex: number) => {
    const tabsList = [...tabsData];
    const row = tabsList.splice(oldIndex, 1)[0];
    tabsList.splice(targetIndex, 0, row);
    const newTabsList = tabsList.map((item) => ({
      ...item,
      toBeEdited: true
    }));
    setTabs(newTabsList);
    const restTabs = tabs.filter((tab) => !tabsList.includes(tab));
    const updatedTabsData =
      restTabs.length > 0 ? [...newTabsList, ...restTabs] : newTabsList;
    setFieldValue('tabs', updatedTabsData);
  };

  return (
    <DataTable
      columns={[
        {
          field: 'publisherTabId',
          headerName: 'ID',
          flex: 1
        },
        {
          field: 'iconUrl',
          headerName: '',
          flex: 1,
          renderCell: (params: any) => {
            return params.row.iconUrl ? (
              <img
                style={{
                  maxHeight: '50%',
                  objectFit: 'contain'
                }}
                src={params.row.iconUrl}
                alt="tabIcon"
              />
            ) : (
              ''
            );
          }
        },
        {
          field: 'name',
          headerName: 'Name',
          flex: 1
        },
        {
          field: 'remove',
          headerName: 'Remove',
          renderCell: (params) => (
            <IconButton onClick={() => removeTab(params.row._id)}>
              <DeleteIcon />
            </IconButton>
          ),
          flex: 1
        },
        {
          field: 'edit',
          headerName: 'Edit',
          renderCell: (params) => (
            <IconButton onClick={() => editTab(params.row)}>
              <EditIcon />
            </IconButton>
          ),
          flex: 1
        }
      ]}
      rows={tabsData}
      loading={false}
      rowReordering={true}
      onRowOrderChange={(params: GridRowOrderChangeParams) =>
        handleTabsOrderChange(params.oldIndex, params.targetIndex)
      }
    />
  );
};
